Postlogin.CareerCentral = (function () {
    const init = function () {
        $('.career-clusters.grid').on('click', '.grid-item', function () {
            // $(this).siblings().addClass('out');
            $(this).addClass('selected');
            $('.grid-item').not($(this)).addClass('blur');
        });
    };

    return {
        init,
    };
}());
